import { createSlice } from "@reduxjs/toolkit";
import { faq_arr } from "../../../common/utils/constants";
import {
  gedDefaultDocsService,
  getStatesServices,
} from "./documentServiceActions";
import { set } from "react-hook-form";

const initialState = {
  credits: 0,
  faq_arr: [],
  selectedState: [],
  availableStates: {},
  agDocs:[],
  nonAgDocs:[]
};

const docuemntServiceSlice = createSlice({
  name: "docuemntServiceSlice",
  initialState,
  reducers: {
    setcreditsInRedux: (state, { payload }) => {
      state.credits = payload;
    },
    selectedState: (state, { payload }) => {
      state.selectedState = payload;
    },
    setAgDocs:(state,{payload})=>{
      state.agDocs=payload
    },  
    setNonAgDocs:(state,{payload})=>{ 
      state.nonAgDocs=payload
    }
  },
  extraReducers: (builder) => {
    builder.addCase(gedDefaultDocsService.pending, (state) => {});
    builder.addCase(gedDefaultDocsService.fulfilled, (state, { payload }) => {
      state.faq_arr = payload?.response?.data?.documentFaq;
    });

    builder.addCase(gedDefaultDocsService.rejected, (state, { payload }) => {});

    builder.addCase(getStatesServices.pending, (state) => {});

    builder.addCase(getStatesServices.fulfilled, (state, { payload }) => {
      const totalStates = payload?.response?.data;
      const temp = {};
      for (let i = 0; i < totalStates?.length; i++) {
        temp[totalStates[i].name] = {
          id: totalStates[i]?.id,
          documents: totalStates[i]?.documents,
          name: totalStates[i]?.name,
        };
        // .push(totalStates[i])
      }
      state.availableStates = totalStates;
    });

    builder.addCase(getStatesServices.rejected, (state, { payload }) => {});

    // getStatesServices
  },
});

export const { setcreditsInRedux, selectedState, setAgDocs, setNonAgDocs } =
  docuemntServiceSlice.actions;
export default docuemntServiceSlice.reducer;
// const
